import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";

const useCartBookingCompleteMutation = () => {
  const { callApi } = useContext(UserContext);
  const { setSlotNotAvailable, setCurrentSectionIndex, setCartRequest } = useContext(CartContext);

  return useMutation(
    ({ campaignId, answerId, pickUpPointId, reservationId }) =>
      callApi(`/cart/booking/${campaignId}/completeBooking/${answerId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pickupPointId: Number(pickUpPointId),
          reservationId,
        }),
      }),
    {
      onSuccess: () => {
        setCurrentSectionIndex((current) => current + 1);
        setSlotNotAvailable(false);
        setCartRequest((current) => {
          return {
            ...current,
            status: "BOOKED",
            // evita di far vedere la data di reservation vecchia alla navigazione verso la pagina col summary
            previousReservationStart: null,
            previousReservationEnd: null,
            previousReservationId: null,
          };
        });
      },
      onError: (error) => {
        if (error.status === 403) {
          setCurrentSectionIndex((current) => current + 1);
          setSlotNotAvailable(true);
        }
      },
    }
  );
};

export default useCartBookingCompleteMutation;
